import * as React from 'react';
import { HeaderContext } from '@core-front/header-provider';
const MainHeader = (props) => {
    const { headerHeight } = React.useContext(HeaderContext);
    const { children, className, } = props;
    const BEM = () => {
        const classArray = ['main__header'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const getStyle = () => {
        return {
            paddingTop: headerHeight,
        };
    };
    return (React.createElement("div", { className: BEM(), style: headerHeight ? getStyle() : undefined }, children));
};
export { MainHeader as default, };
